// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2HaHo","description":"PatientConsentPreview_description__Qu0jO"};